document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('seloor-product-motion');
  const toggle = document.querySelector('[data-seloor-video-toggle]');
  if (!video || !toggle) return;

  const syncButton = () => {
    const isPaused = video.paused;
    toggle.textContent = isPaused ? 'Play' : 'Pause';
    toggle.setAttribute('aria-label', isPaused ? 'Play product video' : 'Pause product video');
    toggle.setAttribute('aria-pressed', String(isPaused));
  };

  toggle.addEventListener('click', async () => {
    if (video.paused) {
      try { await video.play(); } catch (_) { syncButton(); }
    } else {
      video.pause();
    }
    syncButton();
  });

  video.addEventListener('play', syncButton);
  video.addEventListener('pause', syncButton);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
  syncButton();
});
